"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossTab = void 0;
class CrossTab {
    constructor() {
        this.key = 'mgm_crosstab';
        this.maxLog = 3;
        this._handlers = {};
        this.storage = typeof window !== 'undefined' ? window.localStorage : {};
        this.emit = (event) => {
            if (!this.enabled) {
                return;
            }
            const log = this.getEventLog();
            const lastLog = this.getLastEntry(log);
            if (log.length >= this.maxLog) {
                log.shift();
            }
            // Do not re-emit the same event unless enough time has passed
            if ((lastLog === null || lastLog === void 0 ? void 0 : lastLog.key) !== event.key || this.reEmitEvent(lastLog)) {
                log.push(Object.assign(Object.assign({}, event), { data: Object.assign(Object.assign({}, event.data), { timeStamp: new Date() }) }));
                this.storage.setItem(this.key, JSON.stringify(log));
            }
        };
        this.on = (key, handler) => {
            if (this._handlers[key]) {
                this._handlers[key].push(handler);
            }
            else {
                this._handlers[key] = [handler];
            }
        };
        try {
            const key = `${this.key}_test_storage`;
            this.storage.setItem(key, '-');
            this.storage.removeItem(key);
            this.enabled = true;
            if (typeof window !== 'undefined') {
                window.addEventListener('storage', (event) => {
                    if (event.key === this.key) {
                        const log = this.getEventLog();
                        const lastLog = this.getLastEntry(log);
                        if (lastLog) {
                            const handlers = this._handlers[lastLog.key];
                            handlers === null || handlers === void 0 ? void 0 : handlers.forEach(handler => handler(lastLog.data));
                        }
                    }
                });
            }
        }
        catch (e) {
            this.enabled = false;
        }
    }
    getEventLog() {
        const rawLog = this.storage.getItem(this.key);
        const log = JSON.parse(rawLog !== null && rawLog !== void 0 ? rawLog : '[]');
        return log;
    }
    getLastEntry(log) {
        return log.length > 0 ? log[log.length - 1] : null;
    }
    reEmitEvent(log) {
        if (!log) {
            return true;
        }
        const timeStamp = log.data.timeStamp;
        if (!timeStamp) {
            return true;
        }
        try {
            const diff = new Date().valueOf() - new Date(timeStamp).valueOf();
            const minutes = Math.floor(diff / 1000 / 60);
            return Math.abs(minutes) > 5;
        }
        catch (_a) {
            return true;
        }
    }
}
exports.CrossTab = CrossTab;
